import { render, staticRenderFns } from "./AbfFilterItem.vue?vue&type=template&id=57c83d0b&scoped=true&"
import script from "./AbfFilterItem.vue?vue&type=script&lang=js&"
export * from "./AbfFilterItem.vue?vue&type=script&lang=js&"
import style0 from "./AbfFilterItem.vue?vue&type=style&index=0&id=57c83d0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c83d0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemAction,VListItemContent,VListItemTitle})
